module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-11.73e37e13.png";